import { useApiPostRequest } from '../hooks/useApiPostRequest';
import {
  POST_GENERATE_UPLOAD_URL_PATH,
  POST_MULTIPART_UPLOAD_COMPLETE_PATH,
  POST_MULTIPART_UPLOAD_GENERATE_PATH,
  PostGenerateUploadUrlErrorDto,
  PostGenerateUploadUrlRequestBodyData,
  PostGenerateUploadUrlRequestPathVariables,
  PostGenerateUploadUrlRequestQueryParams,
  PostGenerateUploadUrlSuccessDto,
  PostMultipartUploadCompleteErrorDto,
  PostMultipartUploadCompleteRequestBodyData,
  PostMultipartUploadCompleteRequestPathVariables,
  PostMultipartUploadCompleteRequestQueryParams,
  PostMultipartUploadCompleteSuccessDto,
  PostMultipartUploadGenerateErrorDto,
  PostMultipartUploadGenerateRequestBodyData,
  PostMultipartUploadGenerateRequestPathVariables,
  PostMultipartUploadGenerateRequestQueryParams,
  PostMultipartUploadGenerateSuccessDto,
} from './types/file';

export const usePostMultipartUploadGenerate = () => {
  return useApiPostRequest<
    PostMultipartUploadGenerateRequestPathVariables,
    PostMultipartUploadGenerateRequestQueryParams,
    PostMultipartUploadGenerateRequestBodyData,
    PostMultipartUploadGenerateSuccessDto,
    PostMultipartUploadGenerateErrorDto
  >(POST_MULTIPART_UPLOAD_GENERATE_PATH);
};

export const usePostMultipartUploadComplete = () => {
  return useApiPostRequest<
    PostMultipartUploadCompleteRequestPathVariables,
    PostMultipartUploadCompleteRequestQueryParams,
    PostMultipartUploadCompleteRequestBodyData,
    PostMultipartUploadCompleteSuccessDto,
    PostMultipartUploadCompleteErrorDto
  >(POST_MULTIPART_UPLOAD_COMPLETE_PATH);
};

export const usePostGenerateUploadUrl = () => {
  return useApiPostRequest<
    PostGenerateUploadUrlRequestPathVariables,
    PostGenerateUploadUrlRequestQueryParams,
    PostGenerateUploadUrlRequestBodyData,
    PostGenerateUploadUrlSuccessDto,
    PostGenerateUploadUrlErrorDto
  >(POST_GENERATE_UPLOAD_URL_PATH);
};
